import type { PerformanceDeltaSort } from "@/features/performanceDeltas/PerformanceDeltaSort";
import type { PerformanceDeltaStep } from "@/features/performanceDeltas/PerformanceDeltaStep";
import type { Money } from "@/lib/domain/Money";
import { useHTTP } from "@/lib/http";
import type { PaginatedResponseModel } from "@/lib/http/PaginatedResponseModel";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export interface CollectionPerformanceDeltaResponseModel {
	readonly variantId: string;
	readonly productId: string;
	readonly fcId: string;
	readonly productName: string;
	readonly imageUrl: string;
	readonly currentPrice: Money;
	readonly previousPrice: Money;
	readonly delta: Money;
	readonly saleVolumes: number[];
}

export const useCollectionPerformanceDeltas = (collectionId: string, searchQuery: string, step: PerformanceDeltaStep, minimumPrice: number, sort: PerformanceDeltaSort) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["collection", collectionId, "performanceDeltas", searchQuery, step, minimumPrice, sort],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<CollectionPerformanceDeltaResponseModel>>({
				method: "GET",
				url: `/performance-deltas/search/collection/${collectionId}?q=${searchQuery}&step=${step}&minimumPrice=${minimumPrice}&sort=${sort}&cursor=${pageParam}`
			});
		}
	});
};
